import React from 'react';
import connect from 'Shared/connect';
import Root from './Root';
import MainFooter from './Footer';
import Sliding from './Sliding';
import AccountBox from './Header/AccountBox';
import Overlay from 'Shared/Overlay';
import { setAccountBoxClose } from './Header/AccountBox/action-creators';
import Flyout from 'Shared/Flyout';
import MiniCart from './MiniCart';
import Loader from './Loader';
import CurrentPage from './CurrentPage';
import NetworkError from './NetworkError';
import GenericFeedbackBar from './GenericFeedbackBar';
import { toggleMainMenu } from './MainMenu/action-creators';
import { toggleMiniCart } from './MiniCart/action-creators';
import { closeQuickSearch } from './../Search/action-creators';
import miniCartIsDisabled from './MiniCart/is-disabled-selector';
import { SMALL } from 'Shared/breakpoints';
import resolveComponent from 'Shared/resolve-component';
import { base as layout, baseApp as layoutApp } from './base.scss';
import moment from 'moment';
import { updateAppShellData } from './../AppShell/action-creators';
import { pageHasAppShell } from './../AppShell/';
import InfoModal from '../InfoModal';
import AutomaticLogout from 'Shared/AutomaticLogout';
import { renderMeta } from './meta-data-handling';
import CustomVariables from './CustomVariables';
import { toggleDeliveryDays } from './Header/action-creators';
import DeliveryDatesMobile from './Header/FadeHeader/Components/Buttons/DeliveryDates/DeliveryDatesMobile/index';
import { componentIsCategory, isCategoryPageType } from './../Category/Commerce/Components/current-page-is-category';
import { isProductPage } from './../Product/Commerce/current-page-is-product';
import { isSearchPage } from './../Search/Pages/Search/current-page-is-search';
import isCheckoutPage from '../Checkout/Pages/Checkout/current-page-is-checkout';
import isStartPage from '../Start/Pages/Start/current-page-is-start';
import isOrderConfirmation from '../Checkout/Pages/OrderConfirmation/current-page-is-order-confirmation';
import MainHeader from './Header/MainHeader';
import MfaModal from '../MfaModal';
import { urlToString } from 'Shared/url';
import * as imagestyles from '../Shared/ImageFallback/base.scss';
import '../../styles/index';
function hasConsentForFunctional() {
    const activeGroups = window.OnetrustActiveGroups;
    return typeof activeGroups === "string" && activeGroups.includes("C0002");
}
export const siteContentMaxWidth = 1200;
class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.zaiusLoaded = false;
        this.onConsentChanged = () => {
            if (hasConsentForFunctional()) {
                this.loadZaius();
            }
        };
        moment.locale('sv');
        moment.locale('en');
        this.scrollPosition = props.currentPage.scrollPosition;
    }
    componentDidMount() {
        this.addTrackingScriptsToHead();
        if (process.env.NODE_ENV !== 'production') {
            setTimeout(() => {
                this.prefixImageUrlsForDevelopEnviorments();
            }, 1000);
        }
        window.addEventListener("OneTrustGroupsUpdated", this.onConsentChanged);
        window.addEventListener("gdprDataReady", this.onConsentChanged);
    }
    componentWillUnmount() {
        window.removeEventListener("OneTrustGroupsUpdated", this.onConsentChanged);
        window.removeEventListener("gdprDataReady", this.onConsentChanged);
    }
    addTrackingScriptsToHead() {
        this.addPeeriusCallback();
        const peeriusScript = document.createElement("script");
        peeriusScript.type = "text/javascript";
        peeriusScript.src = this.props.PeeriusURL;
        peeriusScript.charset = "UTF-8";
        document.head.appendChild(peeriusScript);
        if (hasConsentForFunctional()) {
            this.loadZaius();
        }
    }
    loadZaius() {
        if (this.zaiusLoaded)
            return;
        this.zaiusLoaded = true;
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.text = `
      window.zaius = window['zaius']||(window['zaius']=[]);
      zaius.methods=["initialize","onload","customer","entity","event","subscribe","unsubscribe","consent","identify","anonymize","dispatch"];
      zaius.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);zaius.push(t);return zaius}};
      (function(){
        for(var i=0;i<zaius.methods.length;i++){
          var method=zaius.methods[i];
          zaius[method]=zaius.factory(method)
        }
        var e=document.createElement("script");
        e.type="text/javascript";
        e.async=true;
        e.src=(document.location.protocol==="https:"?"https://":"http://")+"d1igp3oop3iho5.cloudfront.net/v2/${this.props.ODPKey}/zaius.js";
        var t=document.getElementsByTagName("script")[0];
        t.parentNode.insertBefore(e,t)
      })();
    `;
        document.head.appendChild(script);
    }
    addPeeriusCallback() {
        const peeriusScriptCallbacks = document.createElement("script");
        peeriusScriptCallbacks.type = "text/javascript";
        peeriusScriptCallbacks.id = "PeeriusScriptTag";
        peeriusScriptCallbacks.text = this.getPeeriusScript();
        document.head.appendChild(peeriusScriptCallbacks);
    }
    getPeeriusScript() {
        document.dispatchEvent(new CustomEvent("smartRecInit"));
        return 'var PeeriusCallbacks = {track : ' + this.getPeeriusTrackingData(this.props.currentPage) + ', smartRecs: function(jsonData) { document.dispatchEvent(new CustomEvent("smartRecLoaded", {detail: jsonData}));}, apiVersion: "v1_4"}';
    }
    getPeeriusTrackingData(page) {
        if (!!isStartPage(page)) {
            let baseJson = this.props.peeriusTrackingData;
            const json = {};
            Object.assign(json, baseJson, { type: 'home' });
            return JSON.stringify(json);
        }
        else if (!!isSearchPage(page)) {
            return JSON.stringify(page.searchResultsPageTrackingData);
        }
        else if (!!isCheckoutPage(page)) {
            return JSON.stringify(page.checkoutPageTrackingData);
        }
        else if (!!isOrderConfirmation(page)) {
            return JSON.stringify(page.orderConfirmationTrackingData);
        }
        else if (!!isProductPage(page)) {
            return JSON.stringify(page.productPageTrackingData);
        }
        else if (!!isCategoryPageType(page)) {
            return JSON.stringify(page.categoryPageTrackingData);
        }
        else {
            return JSON.stringify(this.props.peeriusTrackingData);
        }
    }
    prefixImageUrlsForDevelopEnviorments() {
        if ((window.document.location.hostname != "localhost"))
            return;
        const domain = "https://int.menigo.se/";
        const images = document.querySelectorAll("img");
        images.forEach((img) => {
            if (img.src && !img.src.startsWith(domain) && !img.classList.contains(imagestyles.disableClicks)) {
                const url = new URL(img.src, window.location.origin);
                img.src = domain + url.pathname.slice(1);
            }
        });
        const elements = document.querySelectorAll("[style]");
        elements.forEach((element) => {
            const style = window.getComputedStyle(element);
            const backgroundImage = style.backgroundImage;
            if (backgroundImage && backgroundImage.startsWith('url("')) {
                const urlMatch = backgroundImage.match(/url\(["']?(.+?)["']?\)/);
                if (urlMatch && !urlMatch[1].startsWith(domain)) {
                    const url = new URL(urlMatch[1], window.location.origin);
                    const prefixedUrl = domain + url.pathname.slice(1);
                    element.style.backgroundImage = `url("${prefixedUrl}")`;
                }
            }
        });
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (componentIsCategory(newProps.currentPage.componentName)) {
            const currentPath = typeof newProps.currentPage.url === "string" ? newProps.currentPage.url : urlToString(newProps.currentPage.url);
            const newPath = this.props.currentPage.url;
            if (!!currentPath && !!newPath) {
                this.scrollPosition = currentPath.startsWith(newPath) || newPath.startsWith(currentPath) ? undefined : newProps.currentPage.scrollPosition;
            }
        }
        else if (this.props.currentPage.url !== newProps.currentPage.url) {
            this.scrollPosition = newProps.currentPage.scrollPosition;
        }
        else {
            this.scrollPosition = undefined;
        }
    }
    componentDidUpdate(prevProps) {
        if (this.scrollPosition !== undefined) {
            document.body.scrollTop = this.scrollPosition;
            document.documentElement.scrollTop = this.scrollPosition;
        }
        if (prevProps.punchOutSessionActive && !this.props.punchOutSessionActive) {
            this.props.updateAppShellData();
        }
        if (this.props.currentPage.url !== prevProps.currentPage.url) {
            if (!(this.props.currentUser.isSupplierSalesman || (this.props.currentUser && this.props.currentUser.customerId))) {
                if (document.getElementById("PeeriusScriptTag")) {
                    document.getElementById("PeeriusScriptTag").innerText = this.getPeeriusScript();
                }
                else {
                    this.addPeeriusCallback();
                }
            }
            if (process.env.NODE_ENV !== 'production') {
                setTimeout(() => {
                    this.prefixImageUrlsForDevelopEnviorments();
                }, 1000);
            }
        }
    }
    render() {
        const hasAppShell = pageHasAppShell(this.props.currentPage.componentName);
        renderMeta(this.props.currentPage);
        return (React.createElement(Root, { className: hasAppShell ? layout : layoutApp },
            hasAppShell && React.createElement(MainHeader, null),
            React.createElement(CurrentPage, { currentBreakpoint: this.props.currentBreakpoint, page: this.props.currentPage, component: resolveComponent(this.props.currentPage.componentName) }),
            hasAppShell && React.createElement(MainFooter, null),
            this.props.currentBreakpoint < SMALL && (React.createElement(React.Fragment, null,
                React.createElement(Sliding, { toggleMainMenu: this.props.toggleMainMenu, canOpen: !this.props.miniCartIsOpen || !this.props.deliveryDaysIsVisible }),
                React.createElement(Flyout, { position: "right", canOpen: !this.props.mainMenu.isOpen && !this.props.miniCartIsDisabled, toggleFlyout: null, isOpen: this.props.miniCartIsOpen, fillWidth: true }, this.props.miniCartIsOpen && React.createElement(MiniCart, { isFlyout: true })),
                React.createElement(Flyout, { position: "right", canOpen: !this.props.mainMenu.isOpen, toggleFlyout: this.props.toggleDeliveryDays, isOpen: this.props.deliveryDaysIsVisible, fillWidth: true },
                    React.createElement(DeliveryDatesMobile, null)))),
            this.props.accountBoxIsOpen && (React.createElement(Overlay, { onClose: () => this.props.setLoginBoxClose() },
                React.createElement(AccountBox, { close: () => this.props.setLoginBoxClose(), isCloseButton: true }))),
            React.createElement(Loader, { isVisible: this.props.currentPage.showLoadingSpinner }),
            React.createElement(NetworkError, { reload: this.props.currentPage.reload, loadFailure: this.props.currentPage.loadFailure }),
            React.createElement(GenericFeedbackBar, null),
            React.createElement(InfoModal, null),
            React.createElement(CustomVariables, null),
            React.createElement(AutomaticLogout, null),
            this.props.currentUser.isLoggedIn && !this.props.currentUser.mfaPopupShown && (React.createElement(MfaModal, null))));
    }
}
export default connect((state) => ({
    currentPage: state.currentPage,
    currentBreakpoint: state.currentBreakpoint,
    mainMenu: state.mainMenu,
    miniCartIsOpen: state.miniCart.isOpen,
    miniCartIsDisabled: miniCartIsDisabled(state),
    accountBoxIsOpen: state.accountBox.isOpen && !state.currentUser.isLoggedIn,
    punchOutSessionActive: state.currentUser.punchOutSessionActive,
    deliveryDaysIsVisible: state.deliveryDaysVisibility.visible,
    headerViewModel: state.appShellData.header,
    ODPKey: state.appShellData.siteSettings.odpEnvironmentKey,
    PeeriusURL: state.appShellData.siteSettings.optiRecsTrackerURL,
    peeriusTrackingData: state.appShellData.peeriusTrackingData,
    currentUser: state.currentUser
}), (dispatch) => ({
    toggleMainMenu: (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        dispatch(closeQuickSearch());
        dispatch(toggleMainMenu());
    },
    toggleMiniCart: (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        dispatch(toggleMiniCart());
    },
    toggleDeliveryDays() {
        return dispatch(toggleDeliveryDays());
    },
    setLoginBoxClose: () => dispatch(setAccountBoxClose()),
    updateAppShellData: () => dispatch(updateAppShellData()),
}))(Layout);
